module.exports = __webpack_public_path__ + "static/media/project2.134a831d.png";